module.exports = __webpack_public_path__ + "img/bluetooth.7ca14af2.svg";